import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { LayoutCenteredBody } from '#/layouts/Layout/LayoutCenteredBody';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { OrgDashboardCreateInternshipPageLoadable } from '#/modules/orgDashboard/pages/internships/create/OrgDashboardCreateInternshipPageLoadable';
import { orgDashboardCreateInternshipRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { OrgDashboardOrgSubLayoutHandleProps } from '#/modules/orgDashboard/sub-layouts/Org/OrgDashboardOrgSubLayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

export const handle = {
  variant: 'base',
  orgDashboardSubLayoutVariant: 'base',
  darkBackground: true,
} satisfies LayoutHandleProps & OrgDashboardOrgSubLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardCreateInternshipRoute>,
) {
  await OrgDashboardCreateInternshipPageLoadable.load();
}

export default function OrgDashboardCreateInternshipHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Create a New Internship Listing')}>
      <LayoutCenteredBody>
        <OrgDashboardCreateInternshipPageLoadable />
      </LayoutCenteredBody>
    </RouteModule>
  );
}
